import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { exportarExcel } from "@/lib/exportExcel";

const esperar = (ms) => new Promise((r) => setTimeout(r, ms));

// hojas: [{ name, selector }] (tabla ya visible) o [{ name, node }] (se dibuja fuera de pantalla para exportarla).
export function ExportExcelButton({ fileName, titulo, hojas, testid = "export-excel", className = "" }) {
  const [busy, setBusy] = useState(false);
  const off = useRef(null);
  const ocultas = hojas.filter((h) => h.node);

  const run = async () => {
    setBusy(true);
    try {
      if (ocultas.length) {
        await esperar(300);
        for (let i = 0; i < 100 && off.current?.querySelector(".animate-spin"); i++) await esperar(200);
        await esperar(300);
      }
      let k = 0;
      const els = hojas.map((h) => ({ name: h.name, el: h.node ? off.current?.children[k++] : document.querySelector(h.selector) }));
      if (!els.some((e) => e.el)) throw new Error("sin tablas");
      await exportarExcel(fileName, titulo, els);
      toast.success("Excel descargado.");
    } catch {
      toast.error("No se pudo exportar a Excel.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button type="button" onClick={run} disabled={busy} data-testid={testid}
        className={`h-9 px-4 rounded-lg border border-emerald-600 text-emerald-700 bg-white text-sm font-semibold hover:bg-emerald-50 disabled:opacity-50 flex items-center gap-2 transition-colors ${className}`}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}Exportar a Excel
      </button>
      {busy && ocultas.length > 0 && createPortal(
        <div ref={off} aria-hidden className="fixed top-0 w-max bg-white text-slate-900" style={{ left: -100000 }}>
          {ocultas.map((h) => <div key={h.name} className="w-max p-2">{h.node}</div>)}
        </div>, document.querySelector("[data-export-root]") || document.body)}
    </>
  );
}
